<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header="<i class='fa fa-star'></i> Pendanaan Detail">
            <b-button-group>
                <b-form-group id="exampleInputGroup3"
                    label="Pilih Bulan"
                    label-for="bulan">
                <b-form-select id="bulan" v-model="selected" @change="getPayments(selected)">
                    <option disabled value="">Please select one</option>
                    <option v-for="(value, index) in periode" 
                            :key="index"
                            :value="value.value"
                            
                        >
                            {{ value.text }} 
                        </option>
                </b-form-select>
            </b-form-group>
            </b-button-group>
            <br></br>
            <div v-if="isLoading" > 
                    <center>
                        <v-pulse></v-pulse>
                    </center>
                </div>
                <div v-else class="table-responsive">
                    <table class="table table-striped table-bordered table-hover" >
                        <thead>
                            <tr>
                                <th>No</th> 
                                <th>Tanggal</th>
                                <th>Nominal</th>
                            </tr>
                        </thead>
                        <tbody v-if="payment.length > 0">
                            <tr v-for="(value,index) in payment" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{value.tanggal_transfer}}</td>
                                <td>{{value.nominal}}</td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <td colspan="3">
                                <center>
                                    Tidak Ada Data
                                </center>
                            </td>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="2">
                                    Total Donasi
                                </td>
                                <td>
                                    Rp. {{total}}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
          </b-card>
        </b-col><!--/.col-->
      </b-row><!--/.row-->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {getCache,storedCache} from '@/cache'
import constant from '../../../store/constant';
export default {
  data () {
    return {
        isLoading: true,
        isModalVisible: false,
        payments: [],
        periode : [],
        selected : "",
        total : null
    }
  },
  created(){
     this.getPeriode()
  },
  beforeMount()
  {
    
  },
  watch: {
    '$route' : 'getFunding'
  },
  methods:{
      openSpinner()
      {
        this.isLoading = true
      },
      closeSpinner()
      {
        this.isLoading = false
      },
      getPeriode()
      {
            const token = localStorage.getItem(`user_token`);
            const user_id = localStorage.getItem(`user_id`);
            let data = {
                'funding_id' : this.$route.params.funding_id
            }
            axios.post(constant._BASE_URL+"payment/periode",data,{ 
                headers: {
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
                }
            }).then(response => {
                    var res = []
                    res = response.data
                    storedCache('periode_'+user_id, res)
                    const monthNames = ["January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"
                    ];
                    for(let i=0;i<res.length;i++)
                    {
                        var d = new Date(res[i]['month']);
                        // this.selected = res[0]['id']
                        let data = {
                            'text' : monthNames[d.getMonth()] +' '+d.getFullYear(),
                            'value' : res[i]['id']
                        }
                        this.periode.push(data)
                    }

            }).catch(error => {
                    alert(error)
                    var res = []
                    res = getCache('periode+'+user_id)
                    const monthNames = ["January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"
                    ];
                    for(let i=0;i<res.length;i++)
                    {
                        var d = new Date(res[i]['month']);
                        this.selected = res[0]['id']
                        let data = {
                            'text' : monthNames[d.getMonth()] +' '+d.getFullYear(),
                            'value' : res[i]['id']
                        }
                        this.periode.push(data)
                    }
            });
           
      },
      getPayments(evt)
      {
        const id = evt
        const token = localStorage.getItem(`user_token`);
        const community_id = localStorage.getItem('user_id');
        let data = {
            "payment_id":id
        }
        this.openSpinner()
        axios.post(constant._BASE_URL+"payment/detail",data,{
            headers:{
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
            }
        }).then(response =>{
            storedCache(`payment_detail`+community_id, response.data)
            this.payment = getCache(`payment_detail`+community_id)
            this.total = 0
            for( let i=0;i<this.payment.length;i++)
            {
                this.total = this.total + parseInt(this.payment[i]['nominal'])
            }
            this.closeSpinner()
        }).catch(error => {
            console.log(error)
            this.closeSpinner()
        });
      },
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      getStudent()
      {
            const token = localStorage.getItem(`user_token`);
            const user_id = localStorage.getItem(`user_id`);
            let user_data = {
                'id' : user_id
            }
            axios.post(constant._BASE_URL+"student/all",user_data,{ 
                headers: {
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
                }
            }).then(response => {
            
                    var user = response.data
                    storedCache('student'+user_id, user)
                    console.log("data"+user)
                    this.student = getCache('student'+user_id)
                    for(let i=0;i<this.student.length;i++)
                    {
                        let data = {
                            'label' : this.student[i]['name'],
                            'value' : this.student[i]['id']
                        }
                        this.students.push(data)
                    }

            }).catch(error => {
                    alert(error)
                    this.student = getCache('student'+user_id)
                    for(let i=0;i<this.student.length;i++)
                    {
                        let data = {
                            'label' : this.student[i]['name'],
                            'value' : this.student[i]['id']
                        }
                        this.students.push(data)
                    }
            });
           
      },
      addFunding(e)
      {
        const token = localStorage.getItem(`user_token`);
        const community_id = localStorage.getItem('user_id');
        e.preventDefault()
        let formData = new FormData()
        formData.append('student_id', this.selected['value'])
        formData.append('community_id', community_id)
        formData.append('start_date', this.funding.start_date)
        formData.append('end_date', this.funding.end_date)
        formData.append('max_member',this.funding.max_member)
        formData.append('iuran_bulanan',this.funding.iuran_bulanan)
        formData.append('deskripsi',this.funding.deskripsi)
        formData.append('title',this.funding.nama)
        axios.post(constant._BASE_URL+"funding",formData,{
            headers:{
                'Content-type': 'application/json',
                'Authorization' : 'Bearer '+token,
            }
        }).then(response =>{
            this.getFunding()
        }).catch(error => {
            alert(error)
        })
        this.closeModal()
      }
  }
}
</script>
<style scoped>
.imageFile {
  height: 150px;
}
.imageHome {
  width: 30%;
  display: inline-block;
  margin-left: 0dp;
  margin-right: 0dp;
}
</style>



// WEBPACK FOOTER //
// src/components/page/fundings/DetailFunding.vue